class PageMenu {

  constructor() {
    // console.log('PageMenu constructor');
    this.currentSection = '';

  }

  init() {

    let _self = this;

    let pageMenu = $('.t-service__menu-inner');
    // console.log('PageMenu init', pageMenu.find('.swiper-slide').length);
    if(pageMenu.length && pageMenu.find('.swiper-slide').length > 1) {

      this.pageMenuLinks = pageMenu.find('a');
      this.pageMenuSections = $(this.pageMenuLinks.map(function() { return $(this).attr('href'); } ).get().join());

      this.pageMenuLinks.on('click', function(e){

        e.preventDefault();
        e.stopPropagation();

        let currentSectionIndex = _self.findLinkIndexByHref($(this).attr('href').replace('#', ''));
        // console.log('pageMenuSwiper click currentSectionIndex', currentSectionIndex, 'href', $(this).attr('href'));
        self.currentSection = currentSectionIndex;
        if(_self.currentSection != false) _self.pageMenuSwiper.slideTo(currentSectionIndex, 400, false);

      })

      this.pageMenuSwiper = new Swiper($(pageMenu).get(0), {
        slidesPerView: 1,
        autoHeight: true,
        spaceBetween: 24,
        virtualTranslate: false,
        watchOverflow: true,
        slideToClickedSlide: true,
        // direction: 'horizontal',
        navigation: {
          nextEl: $(pageMenu).find('.t-service__menu-next').get(0),
          prevEl: $(pageMenu).find('.t-service__menu-prev').get(0),
        },
        breakpoints: {
          768: {
            watchOverflow: false,
            virtualTranslate: true,
            autoHeight: false,
            spaceBetween: 0,
            grid: {
              fill: 'row',
              // rows: pageMenu.find('.swiper-slide').length
            },
            // direction: 'vertical'
            // slidesPerView: pageMenu.find('.swiper-slide').length,
          },
          // 1024: {
          //   spaceBetween: -10,
          // },
          // 1280: {
          //   spaceBetween: -20,
          // },
        },
        on: {
          slideChangeTransitionStart: function(){
            // console.log('pageMenuSwiper slideChangeTransitionStart', this.activeIndex);
            _self.scrollToTargetAdjusted($($(this.slides[this.activeIndex]).find('a').attr('href')));
            // target.scrollIntoView({
            //   behavior: "smooth",
            //   block: "start"
            // });
          }
        }

      });
      // console.log('pageMenuSwiper initialized ?', this.pageMenuSwiper);

      window.addEventListener( 'scroll', _.throttle(_self.doActiveNav.bind(this), 500, { leading: true, trailing: true } ));

    }



  }

  scrollToTargetAdjusted(element){

    let _self = this;

    var headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) + 54;
    var elementPosition = element.offset().top;
    var offsetPosition = elementPosition - headerOffset;
    var currentSectionIndex = _self.findLinkIndexByHref(element.attr('id'))
    // console.log('scrollToTargetAdjusted element', element);
    // console.log('scrollToTargetAdjusted element currentSectionIndex', currentSectionIndex);
    // console.log('scrollToTargetAdjusted headerOffset', headerOffset);
    // console.log('scrollToTargetAdjusted elementPosition', elementPosition);
    // console.log('scrollToTargetAdjusted offsetPosition', offsetPosition);
    // if(!$('.t-service__menu').hasClass('force-height-0')) {
    //   // if(_self.findLinkIndexByHref(element.attr('id'))))
    // } else {
      if(currentSectionIndex > 0) {

        if($('.t-service__menu').hasClass('force-height-0')) {
          offsetPosition += $('.t-service__menu-inner').outerHeight();
        }
        // console.log('scrollToTargetAdjusted offsetPosition CORRECTED currentSectionIndex > 0', offsetPosition);
      } else {

        offsetPosition -= $('.t-service__menu-inner').outerHeight();
        // console.log('scrollToTargetAdjusted offsetPosition CORRECTED', offsetPosition, _self.findLinkIndexByHref(element.attr('id')));
      }
    // }

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  findLinkIndexByHref(href) {

    let linkIndex = false;

    this.pageMenuLinks.each(function(i,el){
      // console.log('pageMenuLinks', $(el).attr('href'), '#'+href, $(el).attr('href') == '#'+href);
      if($(el).attr('href') == '#'+href) {
        linkIndex = i;
        return false;
      }

    });

    return linkIndex;
  }

  doActiveNav(e) {

    let _self = this;

    this.pageMenuSections.each(function(i,section) {
      // console.log(link.hash, header, section);
      // console.log('section.offsetTop '+section.offsetTop+' <= fromTop '+fromTop+' ? '+(section.offsetTop <= fromTop));
      // console.log('section.offsetTop '+section.offsetTop+'+ section.offsetHeight '+section.offsetHeight+' > fromTop'+fromTop+' ? '+(section.offsetTop + section.offsetHeight > fromTop));

      let fromTop = window.scrollY + parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) + 54;

      let sectionOffsetTop = $(section).offset().top;
      if (
        sectionOffsetTop <= fromTop &&
        sectionOffsetTop + $(section).height() > fromTop
      ) {
        // console.log($(section).attr('id')+' CURRENT');
        if($(section).attr('id') != _self.currentSection) {
          _self.currentSection = $(section).attr('id');
          let currentSectionIndex = _self.findLinkIndexByHref(_self.currentSection);
          console.log('pageMenuSwiper doActiveNav currentSectionIndex', currentSectionIndex, 'self.currentSection', self.currentSection);
          if(_self.currentSection != false) _self.pageMenuSwiper.slideTo(currentSectionIndex, 400, false);

          if(window.innerWidth >= 768) {
            if(currentSectionIndex < 1) {
              $('.t-service__menu').addClass('force-height-0');
            } else {
              $('.t-service__menu').removeClass('force-height-0');
            }
          }
        }

        // link.classList.add("current");
      } else {
        // link.classList.remove("current");
      }

    });
  }


}

export { PageMenu };
